/* eslint-disable no-param-reassign */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-expressions */
import React, { useState } from "react";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import DialogTitle from "@material-ui/core/DialogTitle";
import DateFnsUtils from "@date-io/date-fns";
import { Box, Grid, TextField } from "@material-ui/core";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import { Button } from "../../../../shared/widgets";
import { createContractAction } from "../../../../redux/action-creators/allContractsActionCreator";

function TextFieldComponent(props) {
  return (
    <TextField
      {...props}
      inputProps={{
        readOnly: Boolean(true),
      }}
    />
  );
}

const businessGuaranteedContractRenew = (One, raw) => {
  if (One.contractType && One.contractType === "businessGuaranteed") {
    raw.unit = One.unit;
    if (One.is_capping && One.unit === "perDay") {
      raw.is_capping = One.is_capping;
      raw.cappingAmount = +One.cappingAmount;
    }
    if (One.is_threshold) {
      if (One.unit === "perDay") {
        raw.epkmBG = +One.epkmBG;
        raw.travelKmBG = +One.travelKmBG;
        raw.thresholdTypeBG = One.thresholdTypeBG;
      } else if (One.unit === "perKm") {
        raw.kmWiseThreshold = +One.kmWiseThreshold;
        raw.penalty = +One.penalty;
      }
      raw.is_threshold = One.is_threshold;
    }

    if (One.unit === "perDay") {
      raw.dayWisePaidAmount = +One.dayWisePaidAmount;
    } else {
      raw.kmWisePaidAmount = +One.kmWisePaidAmount;
    }
  }
};

const revenueShareContractRenew = (One, raw) => {
  if (One.contractType === "revenueShare") {
    raw.criteria = One.criteria;
    if (One.criteria === "percentageBased") {
      raw.modeAndPercentage = [
        {
          percentageCriteria: One.percentageCriteria,
          percentage: +One.percentage,
        },
      ];
    }
    if (One.criteria === "perTicketBased") {
      raw.perTicketBased = [
        { ticketCountType: One.ticketCountType, fee: +One.fee },
      ];
    }
  }
};

const flatFeeContractRenew = (One, raw, params) => {
  if (One.contractType === "flatFee") {
    raw.flatFeeCriteria = One.flatFeeCriteria;
    raw.flatFee = +One.flatFee;
    raw.flatFeeOn = One.flatFeeOn || "perBus";
    raw.daysToInclude = One.daysToInclude;
    if (One.flatFeeOn === "perRide") {
      raw.minimumRides = +One.minimumRides;
    } else {
      raw.planName = params?.subscription?.planName;
      raw.planVersion = +params?.subscription?.planVersion;
      raw.subscriptionAddOns = params?.subscription?.addOns || [];
    }
  }
};

const baselineContractRenew = (One, raw) => {
  if (One.contractType === "baseline" && One.baselineCriteria) {
    raw.baselineCriteria = One.baselineCriteria;
    if (One.baselinePercentage && One.baselinePercentage.length > 0) {
      One.baselinePercentage.forEach((record) => {
        record.baseline = +record.baseline;
        record.percentage = +record.percentage;
        record.baselineFlatFee = +record.baselineFlatFee;
      });
      raw.baselinePercentage = One.baselinePercentage;
    }
  }
};

const modifyContract = (params) => {
  const contractDetails = {
    fromDate: params.fromDate,
    toDate: params.toDate,
    busNumbers: [params.busNumber],
    cityId: params.city,
    businessDeals: params.businessDeals,
    expenses: [],
  };

  const { businessDeals: businessDetails = [] } = params;
  if (businessDetails && businessDetails.length > 0) {
    const businessDeals = [];
    businessDetails.forEach((One) => {
      const raw = {};
      raw.contractType = One.contractType;
      businessGuaranteedContractRenew(One, raw);
      revenueShareContractRenew(One, raw);
      flatFeeContractRenew(One, raw, params);
      baselineContractRenew(One, raw);
      businessDeals.push(raw);
    });
    contractDetails.businessDeals = businessDeals;
  }

  contractDetails.expenses = [];
  return contractDetails;
};

function RenewModal(props) {
  const {
    contractData, city, callBack, showModal,
  } = props;
  const { contractDetailError: errors, toDate } = contractData;
  const dispatch = useDispatch();

  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);

  const handleChange = (type, date) => {
    if (type === "from") {
      setFrom(date);
    } else {
      setTo(date);
    }
  };
  return (
    <Dialog
      onClose={() => callBack(null)}
      aria-labelledby="renew-customized-dialog-title"
      open={showModal}
      className="confirmationModal"
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={() => callBack(null)}
      >
        <Box className="modalHeaderWrapper">
          <Box className="dialogTitle">Renew Contract </Box>
          <Box className="closeIcon" onClick={() => callBack(null)}>
            <CloseIcon />
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <Box>
          Current Contract expire on
          {" "}
          <strong>{toDate}</strong>
        </Box>
        <Box mt={2}>Renew Contract from</Box>
        <form className="form-horizontal">
          <Box className="contractDetailsWrapper" ml={1} mt={1}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container spacing={2}>
                <Grid item xs={4} className="customDateWrapper">
                  <KeyboardDatePicker
                    required
                    autoOk
                    animateYearScrolling
                    error={!!errors?.from}
                    helperText={errors?.from ? "Required" : ""}
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="from"
                    label="From"
                    minDate={new Date()}
                    value={from}
                    onChange={(date) => handleChange("from", date)}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    TextFieldComponent={TextFieldComponent}
                  />
                </Grid>
                <Grid item xs={4} className="customDateWrapper">
                  <KeyboardDatePicker
                    required
                    autoOk
                    disableToolbar
                    error={!!errors?.to}
                    helperText={errors?.to ? errors.to : ""}
                    variant="inline"
                    format="MM/dd/yyyy"
                    margin="normal"
                    id="to"
                    label="To"
                    minDate={from}
                    value={to}
                    onChange={(date) => handleChange("to", date)}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                    TextFieldComponent={TextFieldComponent}
                  />
                </Grid>
              </Grid>
            </MuiPickersUtilsProvider>
          </Box>
        </form>
      </DialogContent>
      <DialogActions>
        <Button
          classname="backBtnContainer"
          onClick={() => callBack(null)}
          buttonText="cancel"
        />
        <Button
          classname="submitBtnContainer"
          onClick={() => {
            dispatch(
              createContractAction(
                modifyContract({
                  ...contractData,
                  fromDate: from,
                  toDate: to,
                  city,
                }),
              ),
            );
            callBack(null);
          }}
          buttonText="Renew"
        />
      </DialogActions>
    </Dialog>
  );
}

RenewModal.defaultProps = {
  title: "",
  content: "",
  showModal: false,
  onClick: () => {},
};
RenewModal.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  showModal: PropTypes.bool,
  onClick: PropTypes.func,
};
export default RenewModal;
